import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';
// material
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const Page = forwardRef(({ children, title = '', ...other }, ref) => (
  <Box
      style={{display : "flex", alignItems :"center", justifyContent :"center", paddingBottom : 100}}
      ref={ref} {...other}>
    <Helmet>
      <title>{title} | Infomedia</title>
    </Helmet>

      <div style={{width : "100%", padding : 0, marginTop : 20}}>
          {children}
      </div>

  </Box>
));

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string
};

export default Page;
